/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAIEvaluationsPathParams = NonNullable<operations['listAIEvaluations']['parameters']['path']>;

export type ListAIEvaluationsQueryParams = NonNullable<operations['listAIEvaluations']['parameters']['query']>;

export interface Input extends ListAIEvaluationsPathParams {
  apiVersion?: string;
  query?: ListAIEvaluationsQueryParams;
  header: NonNullable<operations['listAIEvaluations']['parameters']['header']>;
}

export async function listAIEvaluations(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/ai/evaluations', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
